import React, { ReactNode } from 'react'
import get from 'lodash/fp/get'
import { ITableRow } from 'interfaces'

import SorterUpArrow from 'assets/images/SvgComponents/SorterUpArrow'
import SorterDownArrow from 'assets/images/SvgComponents/SorterDownArrow'
// import ChevronIcon from 'assets/images/SvgComponents/ChevronIcon'

import styled from 'styled-components'

const textColor = '#212529'
const lightBlueColor = '#007DBA'
const grayDarkColor = '#4C4F55'
const grayColor = '#E5E5E5'
const grayLightColor = '#f8f8f8'
const whiteColor = '#fff'
const redColor = '#f64225'

type CustomTableProps<DataType> = {
  className?: string
  size?: string
  displayHeader?: boolean
  columnsConfig: any
  headerBackground?: string
  onRowClick?: (item: DataType) => void
  maxHeight?: string
  data: Array<DataType>
  rowStyle?: Record<string, object>
  templateColumns: string
  getRowBackgroundColor?: (item: any) => string
  // getCellTextColor?: (item: DataType) => string,
  tableWidth?: string
  alignItems?: string
  rowDifferentColors?: boolean
  handleSortClick?: (sort_by_column: string, sort_by_order: boolean) => void
  sorter?: any
  noBorder?: boolean
  clearTable?: boolean
  labelColor?: string
}

const CustomTable = <DataType, K>({
  className,
  size,
  displayHeader = false,
  columnsConfig,
  headerBackground,
  // onRowClick,
  maxHeight,
  data,
  rowStyle,
  templateColumns,
  // getRowBackgroundColor,
  // getCellTextColor,
  tableWidth,
  alignItems,
  rowDifferentColors,
  handleSortClick = () => {},
  sorter,
  noBorder,
  clearTable,
  labelColor,
}: CustomTableProps<DataType>) => {
  const filterRows = (row: any, column: any, rowIndex: any) => {
    if (typeof column.dataKey === 'function') {
      if (typeof column.dataKey(row, rowIndex) === 'object') {
        return column.dataKey(row, rowIndex)
      }

      if (get(column.dataKey, row) === null) {
        return '0'
      } else return `${column.dataKey(row, rowIndex)}`
    }

    if (get(column.dataKey, row) === null) {
      return '0'
    } else return `${get(column.dataKey, row)}`
  }
  return (
    <StyledRoot>
      <StyledTableContainer tableWidth={tableWidth} className={className}>
        {displayHeader && (
          <StyledTableHeaderContainer noBorder={noBorder}>
            <StyledTableRow
              background={headerBackground}
              templateColumns={templateColumns}
              size={size}
              alignItems={alignItems}
              className="styled-table-header-row"
              noBorder
            >
              {columnsConfig.map(
                (
                  column: {
                    name: string
                    dataKey: string
                    mandatory: ReactNode
                    sort: boolean
                    sortBy: string
                  },
                  index: number,
                ) => (
                  <StyledTableCell className="table-header-column" key={index}>
                    <StyledText
                      onClick={() => {
                        if (column.sortBy) {
                          handleSortClick(
                            column.sortBy,
                            column.sortBy === sorter.sort_by_column ? !sorter.sort_by_order : true,
                          )
                        }
                      }}
                      key={column.name}
                      weight={600}
                      size={14}
                      cursorPointer={column.sortBy}
                      labelColor={labelColor}
                    >
                      {column.name} {column.mandatory && <StyledMandatory>*</StyledMandatory>}
                    </StyledText>
                    {column.sortBy && (
                      <SorterArrowContainer>
                        <StyledSortIconWrapper
                          onClick={() => handleSortClick(column.sortBy, false)}
                        >
                          <SorterUpArrow
                            color={
                              !sorter.sort_by_order && column.sortBy === sorter.sort_by_column
                                ? lightBlueColor
                                : ''
                            }
                          />
                        </StyledSortIconWrapper>
                        <StyledSortIconWrapper onClick={() => handleSortClick(column.sortBy, true)}>
                          <SorterDownArrow
                            color={
                              sorter.sort_by_order && column.sortBy === sorter.sort_by_column
                                ? lightBlueColor
                                : ''
                            }
                          />
                        </StyledSortIconWrapper>
                      </SorterArrowContainer>
                    )}
                  </StyledTableCell>
                ),
              )}
            </StyledTableRow>
          </StyledTableHeaderContainer>
        )}

        <StyledTableBodyContainer maxHeight={maxHeight}>
          {data.map((row, index) => (
            <StyledTableRow
              indexNum={index}
              rowDifferentColors={rowDifferentColors}
              // onClick={() => onRowClick(row)}
              size={size}
              key={index}
              templateColumns={templateColumns}
              // style={{ ...rowStyle, backgroundColor: getRowBackgroundColor(row) }}
              className="styled-table-row"
              clearTable
            >
              {columnsConfig.map((column: any, columnIndex: number) => (
                <StyledTableCell className="table-body-row" key={columnIndex}>
                  <StyledText size={14}>{filterRows(row, column, index)}</StyledText>
                </StyledTableCell>
              ))}
            </StyledTableRow>
          ))}
        </StyledTableBodyContainer>
      </StyledTableContainer>
    </StyledRoot>
  )
}

export default CustomTable

const StyledRoot = styled.div``

const StyledTableContainer = styled.div<{ tableWidth?: string }>`
  /* width: ${(p) => (p.tableWidth ? `${p.tableWidth} !important` : '900px')}; */

  // @media (max-width: 768px) {
  //   min-width: 960px;
  // }

  // @media (min-width: 968px) {
  //   ${(p) => p.tableWidth && `width: ${p.tableWidth} !important`};
  // }
`

const StyledTableHeaderContainer = styled.div<{ noBorder?: boolean }>`
  border-bottom: ${(p) => (p.noBorder ? 'none' : `2px solid ${grayDarkColor}`)};
  font-weight: 600;
`

const StyledTableBodyContainer = styled.div<{ maxHeight?: string }>`
  max-height: ${(props) => props.maxHeight};
`

const StyledTableRow = styled.div<ITableRow>`
  min-height: 50px;
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  grid-template-columns: ${(props) => props.templateColumns};
  background-color: ${(props) => props.background};
  grid-column-gap: ${(props) => (props.size === 'small' ? 8 : 16)}px;
  align-items: ${(p) => p.alignItems};
  border-bottom: ${(props) => (props.noBorder ? 'none' : `1px solid ${grayColor}`)};
  background-color: ${(p) => p.clearTable && 'inherit !important'};
  border: ${(p) => p.clearTable && 'none !important'};
  ${({ rowDifferentColors, indexNum }) =>
    rowDifferentColors &&
    `
    background-color: ${
      indexNum && indexNum % 2 === 1 ? `${whiteColor} !important` : `${grayLightColor} !important`
    }
  };

  `}

  @media (max-width: 768px) {
    gap: 10px;
  }
`

const StyledTableCell = styled.div<{ size?: string }>`
  display: flex;
  align-items: center;
  padding: 8px;
  box-sizing: border-box;
  ${(props) => props.size === 'small' && 'font-size: 0.65rem;'};
`

const SorterArrowContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 15px;
  margin-left: 8px;
`

const StyledSortIconWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`

const StyledText = styled.div<{
  weight?: number
  size?: number
  cursorPointer?: string
  labelColor?: string
}>`
  font-family: 'Roboto', sans-serif !important;
  ${(p) => p.weight && `font-weight: ${p.weight}`};
  font-size: ${(p) => (p.size ? `${p.size}px` : '16px')};
  color: ${(p) => (p.labelColor ? p.labelColor : textColor)};
  ${(p) => p.cursorPointer && 'cursor: pointer'};
  width: 100%;
`

const StyledMandatory = styled.span`
  color: ${redColor};
`
